import { useMemo } from 'react';
import PropTypes from 'prop-types';
import { useIntl } from '@edx/frontend-platform/i18n';

import messages from './messages';

import CoursesFilterMenu from '../courses-filter-menu';

const CoursesLanguageFilterMenu = ({ languages, onItemMenuSelected }) => {
  const intl = useIntl();

  const courseLanguages = useMemo(
    () => [
      {
        id: 'all-languages',
        name: intl.formatMessage(messages.coursesLanguageFilterMenuAllLanguages),
        value: 'allLanguages',
      },
      ...languages.map(({ label, value }) => ({
        id: value,
        name: label,
        value,
      })),
    ],
    [intl, languages],
  );

  const handleLanguageSelected = (languageValue) => {
    onItemMenuSelected(languageValue);
  };

  return (
    <CoursesFilterMenu
      id="dropdown-toggle-courses-language-menu"
      menuItems={courseLanguages}
      onItemMenuSelected={handleLanguageSelected}
      defaultItemSelectedText={intl.formatMessage(messages.coursesLanguageFilterMenuAllLanguages)}
    />
  );
};

CoursesLanguageFilterMenu.defaultProps = {
  languages: [],
};

CoursesLanguageFilterMenu.propTypes = {
  languages: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
    }),
  ),
  onItemMenuSelected: PropTypes.func.isRequired,
};

export default CoursesLanguageFilterMenu;
